/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const levelStatsSchema = z.object({
  level: z.number(),
  total: z.number(),
  passed: z.number(),
  failed: z.number(),
});

export type ILevelStats = z.infer<typeof levelStatsSchema>;
